import { AccordionSummary } from "@material-ui/core";
import React from "react";

// styles
import styles from "./LAccordionSummary.module.scss";
import cx from "classnames";

interface ILAccordionSummary {
    expandIcon: React.ReactNode;
    size: "large" | "small";
    headerAlign?: "center" | "top";
}

const LAccordionSummary: React.FC<ILAccordionSummary> = (props) => {
    const { expandIcon, size, children } = props;
    const headerAlign = props.headerAlign || "center";

    return (
        <AccordionSummary
            classes={{
                root: cx({
                    [styles["accordion-root"]]: true,
                    [styles["accordion-small-size"]]: size === "small",
                    [styles["accordion-large-size"]]: size === "large",
                    [styles["accordion-root--center"]]: headerAlign === "center",
                    [styles["accordion-root--top"]]: headerAlign === "top"
                }),
                content: styles["accordion-content"],
                expanded: cx({
                    [styles["accordion-expanded"]]: true,
                    [styles["accordion-expanded--center"]]: headerAlign === "center",
                    [styles["accordion-expanded--top"]]: headerAlign === "top"
                })
            }}
            expandIcon={expandIcon}>
            {children}
        </AccordionSummary>
    );
};

export default LAccordionSummary;
